import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

type RecuringAvailabilityConfirmationModalProps = {
  isForDelete: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const RecuringAvailabilityConfirmationModal = ({
  isForDelete,
  onClose,
  onConfirm,
}: RecuringAvailabilityConfirmationModalProps) => {
  const action = isForDelete ? 'Delete' : 'Update';
  const body = isForDelete
    ? "Deleting a repeating time frame removes all upcoming availability for that time. If you only want to remove one day's availability, edit your time frame instead."
    : 'Your changes will be applied to all the other days where this time frame repeats.';

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      body={
        <Box
          data-testid="RecuringAvailabilityConfirmationModal"
          css={{ display: 'flex', flexDirection: 'column', gap: 'default', marginBottom: 'tighter' }}
        >
          <Heading fontFamily="heading-alt" level={4}>
            {action} repeating availability
          </Heading>
          <Paragraph>{body}</Paragraph>
        </Box>
      }
      footer={
        <ButtonGroup aria-label="Modal actions">
          <Modal.Close>
            <TextButton data-testid="RecuringAvailabilityConfirmationModal-CancelBtn">Cancel</TextButton>
          </Modal.Close>
          <Button data-testid="RecuringAvailabilityConfirmationModal-ConfirmBtn" emphasis="filled" onClick={onConfirm}>
            {action}
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default RecuringAvailabilityConfirmationModal;
